import React from 'react';
import _ from 'lodash';

import {
  Box,
  Button,
  styled,
  Typography
} from '@mui/material';
import {
  LoadingOverlay,
  modalUtil,
  Table
} from 'iron-forge-react-modules';
import {
  BaseWidget,
  InviteUserModal,
  PermissionWall
} from 'modules';

import * as dataService from './dataService';
import * as types from './types';



const UsersTableComponent = Table.genTableComponent<types.IUsersTableColumnId>();
const InvitesTableComponent = Table.genTableComponent<types.IInvitesTableColumnId>();

const ContainerBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3)
}));



export interface IProps {
  storeId: string;
}

export const FC: React.FC<IProps> = props => {
  const tuple = dataService.useQuery(props.storeId);
  const {
    modalType2IsOpen,
    setModalIsOpen
  } = modalUtil.useModalTrackers(['inviteUser']);



  function handleClickInviteUser() {
    setModalIsOpen('inviteUser', true);
  }

  function handleCloseInviteUserModal() {
    setModalIsOpen('inviteUser', false);
  }



  const userRows = React.useMemo(
    () => _.map(tuple.data.users, (user): types.IUsersTableRow => ({
      id: user.id,
      columnId2Value: {
        email: {
          type: 'string',
          label: user.email
        },
        fullName: {
          type: 'string',
          label: user.fullName
        }
      }
    })),
    [tuple]
  );

  const inviteRows = React.useMemo(
    () => _.map(tuple.data.invites, (invite): types.IInvitesTableRow => ({
      id: invite.id,
      columnId2Value: {
        recipientEmail: {
          type: 'string',
          label: invite.recipientEmail
        },
        sentAt: {
          type: 'string',
          label: invite.sentAt ? invite.sentAt.toFormat('yyyy-MM-dd @ hh:mm a') : '-'
        }
      }
    })),
    [tuple]
  );

  return (
    <>
      <LoadingOverlay.FC active={tuple.loading} />

      <ContainerBox>
        <PermissionWall.FC
          storeId={props.storeId}
          requiresPermissions={['user_view']}>
          <BaseWidget.FC title="Users">
            {!_.isEmpty(userRows) ? (
              <UsersTableComponent
                columns={[
                  {
                    id: 'email',
                    label: "Email"
                  },
                  {
                    id: 'fullName',
                    label: "Full Name"
                  }

                ]}
                rows={userRows} />
            ) : (
              <Typography>No users found</Typography>
            )}
          </BaseWidget.FC>
        </PermissionWall.FC>

        <PermissionWall.FC
          storeId={props.storeId}
          requiresPermissions={[
            'user_viewInvites'
          ]}>
          <BaseWidget.FC
            title="Invites"
            elAction={(
              <PermissionWall.FC
                storeId={props.storeId}
                requiresPermissions={['user_invite']}>
                <Button
                  variant="contained"
                  onClick={handleClickInviteUser}>
                  Invite User
                </Button>
              </PermissionWall.FC>
            )}>
            {!_.isEmpty(inviteRows) ? (
              <InvitesTableComponent
                columns={[
                  {
                    id: 'recipientEmail',
                    label: "Email"
                  },
                  {
                    id: 'sentAt',
                    label: "Sent at"
                  }
                ]}
                rows={inviteRows} />
            ) : (
              <Typography>
                No unclaimed invites found
              </Typography>
            )}
          </BaseWidget.FC>
        </PermissionWall.FC>
      </ContainerBox>

      {modalType2IsOpen.inviteUser && (
        <InviteUserModal.FC
          storeId={props.storeId}
          onClose={handleCloseInviteUserModal} />
      )}
    </>
  );
};
